<template>
  <my-modal
    :title="modalTit"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :centered="true"
    :footer="false"
  >
    <h3>{{ $t('message["794"]') }}：</h3>
    <div slot="content">
      <cube-form
        :model="model"
        @submit.prevent="submitHandler"
        @validate="validateHandler"
      >
        <cube-form-group>
          <cube-form-item :field="fields[0]" />
        </cube-form-group>
        <cube-form-group class="cube-picker-footer footer">
          <cube-button
            type="reset"
            class="cancel-btn"
            @click="handleCancel"
          >
            {{ $t('message["896"]') }}
          </cube-button>
          <cube-button
            type="submit"
            class="confirm-btn"
          >
            {{ $t('message["915"]') }}
          </cube-button>
        </cube-form-group>
      </cube-form>
    </div>
  </my-modal>
</template>

<script>
import { inquiryApply } from '@/services/inqueryServices'
import MyModal from '@/components/mobile/Modal'

export default {
  components: {
    MyModal
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    inquiryId: {
      type: [String, Number],
      default: () => { }
    }
  },
  data () {
    return {
      confirmLoading: false,
      model: {
        reason: ''
      },
      fields: [
        {
          type: 'textarea',
          modelKey: 'reason',
          label: '',
          props: {
            indicator: false,
            maxlength: 200000,
            autoExpand: true,
            placeholder: this.$t('message["794"]')
          },
          rules: {
            required: true
          },
          messages: {
            required: this.$t('message["1043"]')
          }
        }
      ]
    }
  },
  computed: {
    modalTit () {
      return this.$t('message["1621"]')
    }
  },
  created () {
  },
  methods: {
    hide () {
      this.$emit('update:visible', false)
    },
    validateHandler (result) {
      this.validity = result.validity
      this.valid = result.valid
      // console.log('validity', result.validity, result.valid, result.dirty, result.firstInvalidFieldIndex)
    },
    async submitHandler () {
      if (this.confirmLoading) return

      this.confirmLoading = true
      const chain = await inquiryApply()
      chain
        .onNetSuccess(raw => {
          this.confirmLoading = false
          this.handleCancel()
        })
        .onSuccess(payload => {
          this.$router.push({
            name: 'InqueryList',
            query: {
              ...this.$route.query
            }
          })
        })
        .params({
          inquiryid: this.inquiryId,
          reason: this.model.reason
        })
        .fetch()
    },
    handleCancel () {
      this.hide()
      this.model.reason = ''
      this.confirmLoading = false
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .cube-picker-panel {
  width: 270px;
  height: auto;
}

::v-deep .cube-form_standard .cube-textarea-wrapper {
  height: 72px;
  padding: 6px;
  border: solid 1px $primary-color;
  border-radius: 4px;
}
::v-deep .cube-form_standard .cube-textarea-wrapper.cube-textarea_expanded {
  padding: 6px;
}
.cube-picker-footer ::v-deep {
  margin-top: 16px;
  height: 50px;
  line-height: 50px;
  border-top: solid 1px #dbdbdb;
  .cube-btn {
    display: inline-block;
    width: 50%;
    padding: 0;
    color: $gray2;
    background-color: #fff;
    border-radius: 0;
    &:first-child {
      border-right: solid 1px #dbdbdb;
    }
    &.confirm-btn {
      color: $primary-color;
    }
  }
}
</style>
